import api from "./api";
const home = {
  slider: () => api("SSMinitialize")
};
export default home;
